<template>
  <div class="login_page">
    <div class="login_card">
      <div class="login_box">
        <div class="box_title">欢迎登录 - {{ appTitle }}</div>
        <div class="box_from">
          <el-form
            ref="ruleFormRef"
            :model="model"
            :rules="rules"
            label-width="auto"
          >
            <el-form-item label="" prop="username">
              <el-input
                placeholder="请输入账号"
                v-model="model.username"
                size="large"
                clearable
                @keyup.enter="toLogin"
              >
                <template #prefix>
                  <img
                    src="@/assets/img/icon_account.png"
                    style="width: 20px"
                    alt=""
                  />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input
                placeholder="请输入密码"
                v-model="model.password"
                size="large"
                clearable
                type="password"
                show-password
                @keyup.enter="toLogin"
              >
                <template #prefix>
                  <img
                    src="@/assets/img/icon_password.png"
                    style="width: 21px"
                    alt=""
                  />
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="box_btn">
          <el-button
            class="lg_btn"
            type="primary"
            @click="toLogin"
            :disabled="loginLoading"
          >
            {{ loginLoading ? "登录中..." : "登 录" }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted } from "vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { setStorage, getStorage, removeStorage } from "@/utils";
const store = useStore();
let router = useRouter(); //路由
const route = useRoute();
const model = ref({}); //表单数据
const rules = ref({
  username: [{ required: true, message: "请输入账号", trigger: "blur" }],
  password: [{ required: true, message: "请输入密码", trigger: "blur" }],
}); //表单校验
const ruleFormRef = ref(null);
const loginLoading = ref(false); //登录状态
const appTitle = ref(getStorage("APP_TITLE")); //管理系统标题

// 登录
const toLogin = () => {
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      loginLoading.value = true;
      store
        .dispatch("handleLogin", {
          username: model.value.username,
          password: model.value.password,
        })
        .then(() => {
          store
            .dispatch("getUserInfo")
            .then((res) => {
              ElMessage({
                message: "登录成功",
                type: "success",
              });
              const redirectPath = router.currentRoute.value.redirectedFrom
                ? router.currentRoute.value.redirectedFrom.path
                : "/home";
              router.push(redirectPath);
              loginLoading.value = false;
            })
            .catch((err) => {
              loginLoading.value = false;
              ElMessage({
                message: err,
                type: "error",
              });
            });
        })
        .catch((err) => {
          ElMessage.error(err);
          loginLoading.value = false;
        });
    }
  });
};
</script>

<style lang="scss" scoped>
.login_page {
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/login1.jpg") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .login_card {
    width: 700px;
    height: 480px;
    display: flex;
    align-items: center;
    .login_box {
      width: 480px;
      height: 480px;
      border-radius: 10px;
      background-color: #fff;
      // background: url("~@/assets/img/login_box.png") no-repeat center center;
      // background-size: 100% 100%;
      > div {
        width: 80%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .box_title {
        height: 140px;
        font-weight: bold;
        font-size: 25px;
      }
      .box_btn {
        height: 100px;
        .lg_btn {
          width: 100%;
          height: 50%;
          font-size: 20px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .box_from {
        ::v-deep .el-form {
          width: 100%;
        }
        ::v-deep .el-form-item {
          height: 50px;
          margin-bottom: 30px;
          // margin: 25px 0;
        }
        ::v-deep .el-form-item__label {
          font-size: 18px;
          height: 80px;
          line-height: 80px;
          color: #fff;
        }
        ::v-deep .el-input__wrapper,
        ::v-deep .el-input__inner {
          background-color: #f0f5fc;
        }
      }
    }
  }
}
</style>